// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"80863bef","438":"372ae769","626":"33bc6acc","845":"5af333b1","933":"9caa360d","961":"64ebd9a2"}[chunkId] + ".chunk.css";
};